var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ContactSellerModal from '../components/ContactSellerModal';
import SignInPrompt from '../components/ContactSellerModal/SignInPrompt';
import ListClassifieds from '../components/ListClassifieds';
import { fetchLegacyProps } from '../utils/config';
import { isSender } from '../utils/conversationUtil';
import { groupBy } from '../utils/objectUtil';
import { getQueryParamByName } from '../utils/urlDecoder';
import useLatestConversationList from '../hooks/conversation/useLatestConversationList';
export var bookPageId = 'bookPageWrapper';
var buildContactedClassifieds = function (conversations, user) {
    var classifieds = conversations
        // Ignore classifieds owned by the signed in user,
        // as they should be filtered out already
        .filter(function (conversation) { return isSender(conversation, user); })
        .map(function (conversation) { return ({
        conversation: conversation,
        id: conversation.classified.id,
    }); });
    return groupBy(classifieds, function (classified) { return classified.id; });
};
var findConversationBySellerId = function (conversations, sellerId) { return conversations.find(function (conversation) { return conversation.recipient.id === sellerId; }); };
var BookPage = function (_a) {
    var isbn = _a.isbn, _b = _a.userId, userId = _b === void 0 ? undefined : _b, _c = _a.user, user = _c === void 0 ? undefined : _c, _d = _a.coverUrl, coverUrl = _d === void 0 ? null : _d, _e = _a.useLegacyUserFallback, useLegacyUserFallback = _e === void 0 ? true : _e;
    var _f = useState(null), classifiedShown = _f[0], setShowClassified = _f[1];
    var props = useLegacyUserFallback && user === undefined ? fetchLegacyProps() : null;
    var currentUser = user === undefined ? props === null || props === void 0 ? void 0 : props.user : user;
    var _g = useLatestConversationList(), conversations = _g.conversations, forceReFetch = _g.forceReFetch;
    var mustSignIn = !(currentUser === null || currentUser === void 0 ? void 0 : currentUser.id);
    var contactClassifieds = {};
    if (currentUser && currentUser.id && conversations.length > 0) {
        contactClassifieds = buildContactedClassifieds(conversations, currentUser);
    }
    var openContactSellerModal = function (classified) {
        // Check if any conversation is currently related to this classified
        var classifiedToShow = __assign(__assign({}, classified), { conversation: findConversationBySellerId(conversations, classified.userId) });
        setShowClassified(classifiedToShow);
    };
    var onConversationCreated = function () {
        forceReFetch();
    };
    var closeContactSellerModal = function () { return setShowClassified(null); };
    return React.createElement(React.Fragment, null,
        !!classifiedShown && mustSignIn && React.createElement(SignInPrompt, { classified: classifiedShown, coverUrl: coverUrl, onClose: closeContactSellerModal }),
        classifiedShown && !mustSignIn
            && React.createElement(ContactSellerModal, { classified: classifiedShown, coverUrl: coverUrl, onConversationCreated: onConversationCreated, onClose: closeContactSellerModal }),
        React.createElement(ListClassifieds, { isbn: isbn, onUserContact: openContactSellerModal, contactedClassifieds: contactClassifieds, location: getQueryParamByName('location'), currentUserId: userId, focusOn: parseInt(getQueryParamByName('focus_on'), 10) || undefined }));
};
BookPage.propTypes = {
    isbn: PropTypes.string.isRequired,
    userId: PropTypes.any,
};
export default BookPage;
